import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import App from "./App";
import { apolloClient } from "./services/apolloClient";
import { OrgProvider } from "./contexts/OrgContext";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <OrgProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </OrgProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
